import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { openInvoice } from "@/components/InvoicesList";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const cart = params.get("cart") || "";
  const { setUser } = useAuth();
  const [st, setSt] = useState(null);
  useEffect(() => {
    let n = 0, t;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/${cart}`);
        setSt(data);
        if (data.status === "pending" && n++ < 20) { t = setTimeout(poll, 3000); return; }
        if (data.status === "paid") api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});
      } catch { setSt({ status: "error" }); }
    };
    if (cart) poll(); else setSt({ status: "error" });
    return () => clearTimeout(t);
  }, [cart, setUser]);

  const paid = st?.status === "paid";
  const pending = !st || st.status === "pending";
  return (
    <div className="max-w-lg mx-auto glass rounded-2xl p-8 text-center space-y-4 mt-10" data-testid="payment-result">
      {pending ? <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto" />
        : paid ? <CheckCircle2 className="w-14 h-14 text-primary mx-auto" /> : <XCircle className="w-14 h-14 text-destructive mx-auto" />}
      <h1 className="text-2xl font-extrabold" data-testid="payment-status">
        {pending ? "نتأكد من عملية الدفع…" : paid ? "تم الدفع بنجاح" : "لم تكتمل عملية الدفع"}
      </h1>
      {paid && <p className="text-muted-foreground">{st.kind === "wallet" ? `تم شحن محفظتك بمبلغ ${st.amount} ريال.` : `تم تفعيل باقة ${st.plan_name} لمدة شهر.`} أرسلنا الفاتورة على إيميلك.</p>}
      {!pending && !paid && <p className="text-muted-foreground">{st?.message || "لم يتم خصم أي مبلغ. تقدر تحاول مرة ثانية."}</p>}
      {st?.test && <p className="text-xs text-accent">وضع تجريبي — لا يتم خصم مبالغ حقيقية.</p>}
      <div className="flex gap-2 justify-center flex-wrap">
        {paid && st.invoice && <Button variant="outline" className="border-border" onClick={() => openInvoice(cart)} data-testid="payment-invoice-btn">عرض الفاتورة</Button>}
        <Button asChild data-testid="payment-back-btn"><Link to="/app/packages">العودة للباقات</Link></Button>
      </div>
    </div>
  );
}
